/**
 * User:saltrichter
 * Date: 07/10/17
 * layout of notification tab in the connection panel
 */
define(function (require) {
    "use strict";

    var template = require("connection-templates/notificationTab/NotificationTabLayout.tmpl");
    var Notifier = require("ui/notifier/Notifier");
    var Loader = require("ui/loader/Loader");
    var NotificationTabLayout = {};
    var LE = require("app");

    //be able to select the different regions and make them display a view
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        NotificationTabLayout = Marionette.Layout.extend({
            className: "notification-tab",
            template: template,
            regions: {
                notificationRegion : ".notification-tab-region",
                notificationListRegion : ".notification-tab-region .notification-list"
            },
            ui: {
                notificationRegion : ".notification-tab-region"
            },

            initialize: function (options) {
                options = options || {};
                this.mainContainerLayout = options.mainContainerLayout;
            },
            scrollTop:function(){
                this.ui.notificationRegion.scrollTop(0);
            },
            hideRegions: function(){
                this.ui.notificationRegion.addClass("hide");
            },
            showRegions: function(){
                this.ui.notificationRegion.removeClass("hide");
            }
        });
    });

    return NotificationTabLayout;

});

